import { ITheme, IStyle, mergeStyleSets, getTheme } from '@fluentui/react';
import React, { useEffect, useRef, useState } from 'react';
import { BwjEventArgs } from '../../../framework/entities/bwj-event';
import { BwjBillboard } from '../../../framework/components/bwj-billboard';

interface ILoadingOverlayProps {
  overlayDisplayArgs: BwjEventArgs<{ display: boolean, message?: string }> | undefined;
}

const getStyleClasses = (theme: ITheme) => {
  const root: IStyle = {
    display: 'flex',
    position: 'absolute',
    backgroundColor: theme.palette.white,
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    zIndex: 100,
  };

  return mergeStyleSets({
    root,
  });
}

export const LoadingOverlay: React.FunctionComponent<ILoadingOverlayProps> = (props) => {
  const theme = getTheme();
  const cs = getStyleClasses(theme);
  const [showOverlay, setShowOverlay] = useState(false);
  const loadingMessage = useRef('');
  const { overlayDisplayArgs } = props;

  useEffect(() => {
    if(!overlayDisplayArgs || overlayDisplayArgs.inaccessible()) { return; }
    const args = overlayDisplayArgs.getArgs();
    setShowOverlay(args.display);
    args.display && (loadingMessage.current = args.message ?? '');
  }, [overlayDisplayArgs]);

  return (
    <>
    {showOverlay &&
    <div className={cs.root}>
      <BwjBillboard
        icon={'spinner'}
        message={loadingMessage.current}
      />
    </div>}
    </>
  );
};
